import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

/**
 * Supabase client used for **Realtime subscriptions only**.
 * All data fetching goes through the Fastify backend API.
 *
 * Auth tokens are managed in-memory (from GET /api/auth/token) and
 * set via `supabase.auth.setSession()` — not via cookies on this client.
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Don't persist sessions in localStorage — we manage tokens in-memory
    // via the backend cookie-based auth.
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
});

/**
 * Set the access token on the Supabase client for Realtime channel auth.
 * Called after `POST /api/auth/anon` or `GET /api/auth/token`.
 */
export async function setRealtimeToken(accessToken: string) {
  // Setting a session with an empty refresh_token is enough for Realtime auth.
  // We don't do DB operations through this client, so refresh is not needed.
  await supabase.auth.setSession({
    access_token: accessToken,
    refresh_token: '',
  });
  await supabase.realtime.setAuth(accessToken);
}
